var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twemoji:flag-liberia",
    clipPath: "url(#clip0_87_13801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7947 19.0253H0.205333C0.40776 19.5113 0.749512 19.9265 1.18752 20.2186C1.62553 20.5107 2.1402 20.6666 2.66667 20.6666H21.3333C21.8598 20.6666 22.3745 20.5107 22.8125 20.2186C23.2505 19.9265 23.5922 19.5113 23.7947 19.0253ZM0 15.874H24V17.5813H0V15.874ZM7.66667 6.41931H24V8.12665H7.66667V6.41931ZM23.7947 4.97465C23.5922 4.48865 23.2505 4.07345 22.8125 3.78136C22.3745 3.48928 21.8598 3.33338 21.3333 3.33331H7.66667V4.97465H23.7947ZM7.66667 9.57065H24V11.278H7.66667V9.57065ZM0 12.722H24V14.4293H0V12.722Z",
    fill: "#BF0A30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.66667 8.126H24V9.57067H7.66667V8.126ZM0 11.278V12.722H24V11.278H8H0ZM7.66667 4.97467V6.41934H24V6C24 5.63667 23.926 5.29067 23.7947 4.97467H7.66667ZM0 14.4293H24V15.874H0V14.4293ZM0 18C0 18.3633 0.074 18.7093 0.205333 19.0253H23.794C23.93 18.7006 24 18.3521 24 18V17.5807H0V18Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.66667 3.33331C1.95942 3.33331 1.28115 3.61426 0.781049 4.11436C0.280952 4.61446 0 5.29274 0 5.99998L0 11.278H8V3.33331H2.66667Z",
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.52946 6.83002L4.00012 5.20135L3.47079 6.83002H1.75879L3.14412 7.83669L2.61479 9.46535L4.00012 8.45869L5.38546 9.46535L4.85612 7.83669L6.24146 6.83002H4.52946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_13801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngland);
export default __webpack_public_path__ + "static/media/england.cc2aceb177d0dfac362d5ee87b2e724f.svg";
export { ForwardRef as ReactComponent };